import React, { useContext } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Box } from "@mui/material";

import SchoolIcon from "@mui/icons-material/School";

import { AnimationOnScroll } from "react-animation-on-scroll";
import "animate.css/animate.min.css";

import { ThemeContext } from "../../context";

import "../Css/about.css";

const Edu = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <Box
      marginTop="20px"
      display="flex"
      flexDirection="column"
      sx={{ cursor: "default" }}
    >
      <Box
        marginTop="12px"
        fontSize={{ xs: "24px", lg: "25px" }}
        fontWeight={{ xs: "200", lg: "400" }}
      >
        Education
      </Box>
      <AnimationOnScroll animateIn="animate__fadeIn" duration={1}>
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
          }}
        >
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  backgroundColor: "transparent",
                  color: darkMode ? "#d4af37" : "#9e9e9e",
                  boxShadow: "none",
                  filter: darkMode
                    ? "drop-shadow(3px 4px 12px #d4af37)"
                    : "drop-shadow(3px 4px 12px #757575)",
                }}
              >
                <SchoolIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                marginTop="12px"
                fontSize={{ xs: "20px", lg: "22px" }}
                fontWeight={{ xs: "200", lg: "400" }}
              >
                Bachelor of Information Management (BIM) |
                <span style={{ marginLeft: "4px" }}>Tribhuvan University</span>
              </Box>
              <Box marginTop="12px">
                <a
                  href="https://morganem.edu.np/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: darkMode ? "#d4af37" : "#757575",
                  }}
                >
                  Morgan Engineering & Management College
                </a>
                <Box marginTop="12px">2017 - 2021</Box>
                <Box marginTop="12px">
                  Skills: OOP, SQL, Backend-End Development.
                </Box>
              </Box>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </AnimationOnScroll>
    </Box>
  );
};

export default Edu;
